import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { AppWrapper } from './model';
import { NavbarView } from 'portcall/navbar/view';
import { NavbarTab } from 'portcall/navbar/view';
import { AjaxErrorsView } from 'core/ajaxerrors/view';
import { UIThemeSetterView } from 'portcall/uithemesetter/view';

export let AppWrapperView = SuperCritical(({ model: m, navbarTab, children } : { model : AppWrapper, navbarTab? : NavbarTab, children? : any }) => {
    return (
        <div className={"app-body " + m.UITheme.CssClasses()}>
            <UIThemeSetterView model={m.UITheme} />
            <NavbarView tab={navbarTab} model={m.Navbar} />
            <AjaxErrorsView model={m.AjaxErrors} />
            {children}
        </div>
    );
});


// WEBPACK FOOTER //
// ./apps/portcall/appwrapper/view.tsx